import { X, Eye, ExternalLink } from "lucide-react";
import { PencilIcon } from "@heroicons/react/outline";

import { Button } from "../../button";

interface FileActionsProps {
  onView?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onOpenExternal?: () => void;
  showEdit?: boolean;
  showDelete?: boolean;
  showExternal?: boolean;
}

export const FileActions = ({
  onView,
  onEdit,
  onDelete,
  onOpenExternal,
  showEdit = false,
  showDelete = false,
  showExternal = false,
}: FileActionsProps) => (
  <div className="absolute right-2 top-2 flex gap-1 opacity-0 transition-all duration-200 group-hover/file-item:opacity-100">
    {onView && (
      <Button
        onClick={e => {
          e.stopPropagation();
          onView();
        }}
        variant="ghost"
        size="sm"
        className="group/view-button h-7 w-7 border border-gray-300 bg-white p-0 shadow-md transition-all duration-200 hover:scale-105 hover:bg-blue-50 hover:shadow-lg"
      >
        <Eye className="group/view-button-hover:!text-blue-600 h-3.5 w-3.5 text-gray-600" />
      </Button>
    )}

    {showEdit && onEdit && (
      <Button
        onClick={e => {
          e.stopPropagation();
          onEdit();
        }}
        variant="ghost"
        size="sm"
        className="group/view-button h-7 w-7 border border-gray-300 bg-white p-0 shadow-md transition-all duration-200 hover:scale-105 hover:bg-blue-50 hover:shadow-lg"
      >
        <PencilIcon className="group/view-button-hover:!text-blue-600 h-3.5 w-3.5 text-gray-600" />
      </Button>
    )}

    {showExternal && onOpenExternal && (
      <Button
        onClick={e => {
          e.stopPropagation();
          onOpenExternal();
        }}
        variant="ghost"
        size="sm"
        className="group/view-button h-7 w-7 border border-gray-300 bg-white p-0 shadow-md transition-all duration-200 hover:scale-105 hover:bg-blue-50 hover:shadow-lg"
      >
        <ExternalLink className="h-3.5 w-3.5 text-gray-600" />
      </Button>
    )}

    {showDelete && onDelete && (
      <Button
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          onDelete();
        }}
        variant="ghost"
        size="sm"
        className="h-7 w-7 border border-gray-300 bg-white p-0 shadow-md transition-all duration-200 hover:scale-105 hover:bg-red-50 hover:shadow-lg"
      >
        <X className="h-3.5 w-3.5 text-red-600" />
      </Button>
    )}
  </div>
);
